module.exports = __webpack_public_path__ + "media/img/corporate/events-6ad1f1fe52a04e2c8d4569da1fdce4dd.png";